<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" ref="form" label-width="130px" v-loading="loading">
        <el-row :span="24">
          <el-col :span="12">

            <el-form-item prop="recordDate" label="日期">
              {{ formData.recordDate || '' }}
            </el-form-item>

          </el-col>

          <el-col :span="12">
            <el-form-item prop="photovoltaic" label="光伏发电">
              {{ formData.photovoltaic || "" }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :span="12">

            <el-form-item prop="exhaust" label="废气">
              {{ formData.exhaust || "" }}
            </el-form-item>

          </el-col>

          <el-col :span="12">
            <el-form-item prop="exhaustPurified" label="废气净化">
              {{ formData.exhaustPurified || "" }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="24">
          <el-col :span="12">

            <el-form-item prop="sewage" label="污水">
              {{ formData.sewage || '' }}
            </el-form-item>

          </el-col>

          <el-col :span="12">
            <el-form-item prop="sewagePurified" label="净化污水">
              {{ formData.sewagePurified || '' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="waterUsage" label="用水">
              {{ formData.waterUsage || '' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="electricityUsage" label="用电">
              {{ formData.electricityUsage || '' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="useNaturalGas" label="用天然气">
              {{ formData.useNaturalGas || '' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="useSteam" label="用蒸汽">
              {{ formData.useSteam || '' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="rainwaterTreatment" label="雨水处理">
              {{ formData.rainwaterTreatment || '' }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item prop="fileList" label="附件">
              <div class="row-wrap">

                <div class="images-wrap" v-for="(item, index) of $attachmentFiles(formData.fileList)" :key="index">
                  <el-image style="width: 100%; height: 100%" :src="item.filePrefix + item.fileUrl"
                    :preview-src-list="fileImgUrl" fit="cover" />
                </div>

              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

    </custom-actions>

  </div>
</template>

<script>

export default {
  name: 'GreenEnrgyDetail',

  data () {
    return {
      formData: {

        recordDate: '',
        photovoltaic: '',
        exhaust: '',
        exhaustPurified: '',
        sewage: '',
        sewagePurified: '',
        waterUsage: '', // 用水
        electricityUsage: '', // 用电
        useNaturalGas: '', // 用天然气
        useSteam: '', // 用蒸汽
        rainwaterTreatment: '', // 雨水处理
        fileList: []
      },

      loading: false

    }
  },
  created () {
    if (this.energyId) {
      this.loadData()
    }
  },
  computed: {
    energyId () {
      return this.$route.query.energyId
    },

    fileImgUrl () {
      const arr = this.$attachmentFiles(this.formData.fileList).map(item => {
        return item.filePrefix + item.fileUrl
      })
      return arr
    }

  },
  methods: {

    loadData () {
      this.loading = true
      this.$axios
        .get(this.$apis.greenEnergy.selectPaGreenEnergyByEnergyId, {
          params: { energyId: this.energyId }
        })
        .then(res => {
          res.fileList = res.fileList ? res.fileList : []
          this.formData = res
        })
        .finally(() => {
          this.loading = false
        })
    }

  }
}
</script>

<style scoped lang="scss">
::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-input,
  .el-cascader,
  .el-date-editor {
    width: 100%;
    max-width: 400px;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}

.add-icon {
  font-size: 18px;
  color: #3458f9;
  cursor: pointer;
  font-weight: 600;

}

.del-icon {
  font-size: 18px;
  color: #f22d2d;
  cursor: pointer;
  font-weight: 600;
  margin-right: 14px;

}

.row-wrap {
  display: flex;
  flex-wrap: wrap;
}

.images-wrap {
  width: 148px;
  height: 148px;
  border: 1px dotted #ddd;
  border-radius: 10px;
  position: relative;
  margin-right: 14px;

  .close-icon {
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
    z-index: 10;
    font-size: 18px;
    color: red;
    cursor: pointer;
  }
}
</style>
